import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import React, { useMemo } from 'react';
import { Platform, View } from 'react-native';
import { Text } from '~/components';
import type { InvoiceDetails } from '~/credsystem/domain/invoices';
import { formatMoney } from '~/utils';

import ShoppingBagSVG from '~/credsystem/assets/svgs/shopping-bag.svg';
import CheckSVG from '~/credsystem/assets/svgs/check.svg';
import colors from '~/assets/themes/colors';

interface Props {
  data: InvoiceDetails;
}

const InvoiceItem: React.FC<Props> = ({ data }) => {
  const isCredit = useMemo(() => data.debitValue <= 0, [data.debitValue]);

  const iconInfos = useMemo(() => {
    if (isCredit) {
      return {
        src: <CheckSVG width={19} height={22} color={colors.light[100]} />,
        bgColor: 'bg-credsystem-success-300',
      };
    }

    return {
      src: (
        <ShoppingBagSVG color={colors.secondary[700]} width={20} height={20} />
      ),
      bgColor: 'bg-gray-100',
    };
  }, [isCredit]);

  return (
    <View
      className={`px-4 py-3 bg-light-100 rounded-md w-full shadow flex-row items-center ${
        Platform.OS === 'android' ? 'shadow-black/40' : ''
      }`}
    >
      <View
        className={`rounded-full ${iconInfos.bgColor} w-[40px] h-[40px] items-center justify-center`}
      >
        {iconInfos.src}
      </View>

      <View className="ml-3 flex-row items-center justify-between flex-1">
        <View className="flex-1">
          <Text className="text-xs text-gray-600">
            {format(parseISO(data.transaction), 'dd MMM', { locale: ptBR })}
          </Text>
          <Text className="text-sm text-gray-700" numberOfLines={1}>
            {data.description}
          </Text>
        </View>

        <View>
          {!isCredit && !!data.installment && (
            <>
              <Text className="text-xs text-gray-600 text-right">
                {data.installment}
              </Text>
              <Text className="text-sm text-gray-700">
                {formatMoney(data.debitValue, true)}
              </Text>
            </>
          )}
        </View>
      </View>
    </View>
  );
};

export default InvoiceItem;
